<main class="events-page">
  <h1 class="page-heading">Events</h1>
  <section class="search-section">
    <mat-form-field
      class="search-box"
      appearance="outline"
      subscriptSizing="dynamic"
      floatLabel="always"
    >
      <mat-icon matSuffix>search</mat-icon>
      <mat-label>Search</mat-label>
      <input
        #searchInput
        [value]="getCurrentSearch()"
        (input)="
          search({ searchTerm: searchInput.value, searchType: 'eventName' })
        "
        matInput
        type="text"
        placeholder="Search"
      />
    </mat-form-field>
    @if (isOverviewer) {
      <section class="filters-section">
        <mat-form-field
          class="search-box"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-label>Event Type</mat-label>
          <mat-select
            [(value)]="selectedEventType"
            (selectionChange)="
              search({ searchTerm: $event.value, searchType: 'eventType' })
            "
          >
            @for (eventType of eventTypeOptions; track eventType) {
              <mat-option [value]="eventType">{{ eventType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="search-box"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-label>Filter by year</mat-label>
          <mat-select
            [(value)]="selectedDate"
            (selectionChange)="filterActiveApplicationsByDate($event)"
          >
            @for (date of dateOptions; track date) {
              <mat-option [value]="date">{{ date }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </section>
    }
  </section>
  @if (!isLoading) {
    <article class="events" [ngClass]="{ 'student-events': isStudent }">
      @for (event of events; track event) {
        <section id="events-section" class="event">
          <app-event-summary
            [event]="event"
            [year]="selectedDate"
            (refresh)="refresh($event)"
          ></app-event-summary>
        </section>
      }
      @if ((!events || events.length === 0) && !isLoading) {
        <section class="error-text-container">
          <app-error-message
            [errorMessage]="noEventErrorMessage"
          ></app-error-message>
        </section>
      }
    </article>
  }
</main>

<app-loader></app-loader>
